<div class="flex flex-col bg-navy-700">
  <app-header></app-header>

  <main class="mt-20 bg-white">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</div>
